var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-form',{staticStyle:{"width":"350px"}},[_c('dx-group-item',{attrs:{"css-class":"second-group"}},[_c('dx-group-item',[_c('dx-simple-item',{attrs:{"editor-options":_vm.searchOptions,"editor-type":"dxSelectBox"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }